import React from "react";
import { IoAdd } from "react-icons/io5";
import CreditNoteList from "./CreditNoteList";
import CreditNoteForm from "./CreditNoteForm";
import { NavLink, useParams } from "react-router-dom";
import { hasPermission } from "../../../../../utils/permission";
import { AccessDenied } from "../../../../../shared-ui/States";

const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

function CreditNote() {
  const listPermission = hasPermission("ar-credit-note", "view");
  
  return (
    <div className="projects-page">
      <header className="page-header-projects">
        <div className="header-text-content">
          <h1>Credit Notes</h1>
          <p>View and manage all credit notes.</p>
        </div>
        <NavLink to="/ar/credit-notes/new">
          <button className="create-project-button-header">
            <PlusIcon /> Create New Credit Note
          </button>
        </NavLink>
      </header>
      {listPermission ? (
        <CreditNoteList />
      ) : (
        <AccessDenied description="You do not have permission to view this." />
      )}
    </div>
  );
}

export const CreditNoteFormPage = () => {
  let { id } = useParams();
  const createPermission = hasPermission("ar-credit-note", "create");
  const updatePermission = hasPermission("ar-credit-note", "set");
  
  if (id === "new") {
    if (!createPermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
    id = null;
  } else {
    if (!updatePermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
  }
  
  return (
    <div className="projects-page">
      <NavLink to="/ar/credit-notes">
        <button className="backbutton">Back To Credit Notes</button>
      </NavLink>
      <CreditNoteForm rowId={id} />
    </div>
  );
};

export default CreditNote;
